import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Catalog from "@/components/Catalog";
import Services from "@/components/Services";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/wa";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    const raf = (t) => {
      lenis.raf(t);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain relative">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ContactForm />
        <Catalog />
        <Services />
      </main>
      <Footer />
      <a
        data-testid="floating-whatsapp-button"
        href={waLink("Salve Delta R.E.M., vorrei informazioni sui vostri motori.")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Scrivici su WhatsApp"
        className="wa-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-[#0B0C10] transition-transform duration-300 hover:scale-110"
      >
        <MessageCircle className="h-7 w-7" strokeWidth={2.2} />
      </a>
    </div>
  );
}

export default App;
